import { Icon } from 'core-ui';
import { CustomIconComponentProps } from 'src/models/icon';
import { DashboardSvg } from './svg';

export const DashboardIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DashboardSvg} {...props} />
);
